var _adaptiveUrl = "";
export function adaptiveUrl() {
  return _adaptiveUrl;
}

var _gmSessionId = "";
export function gmSessionId() {
  return _gmSessionId;
}

export default function init(adaptiveUrl, gmSessionId) {
  _adaptiveUrl = adaptiveUrl;
  _gmSessionId = gmSessionId;
}